// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".history-export-modal .history-export-modal__footer.space-lg[data-v-5c5f7536]{margin-top:320px}.history-export-modal .history-export-modal__footer.space-md[data-v-5c5f7536]{margin-top:180px}.history-export-modal .time-period[data-v-5c5f7536]{max-width:250px}", ""]);
// Exports
module.exports = exports;
